import React from "react";
import { useParams } from "react-router-dom";
import FuelReportsPage from "./FuelReportsPage";
import VehicleConsumptionReport from "./VehicleConsumptionReport";
import FuelDashboard from "./FuelDashboard";
import VehicleGPSFuelReport from "./VehicleGPSFuelReport";
import RegionalFuelReportPage from "./RegionalFuelReportPage";
import { FuelReportsProvider } from "../../contexts/FuelReportsContext";

const FuelReportsRouter: React.FC = () => {
  const { type } = useParams<{ type?: string }>();

  // Route to specific fuel report components based on type
  switch (type) {
    case "regional-analysis":
      return <RegionalFuelReportPage />;
    case "vehicle-consumption":
      return <VehicleConsumptionReport />;
    case "staff-performance":
      return <VehicleConsumptionReport />; // For now, using same component
    case "model-efficiency":
      return <VehicleConsumptionReport />; // For now, using same component
    case "source-comparison":
      return <VehicleConsumptionReport />; // For now, using same component
    case "month-on-month":
      return <VehicleConsumptionReport />; // For now, using same component
    case "dashboard":
      return <FuelDashboard />;
    case "export":
      return <VehicleConsumptionReport />; // For now, using same component
    case "vehicle-gps-fuel-report":
      return <VehicleGPSFuelReport />;
    default:
      return <FuelReportsPage />;
  }
};

export default FuelReportsRouter;
